import Utils from '@/common/utils';

export default {
  exportPptx: function <TFilter>(
    pathUrl: string,
    request: TFilter,
    fileName: string = 'Мониторинг_реализации_документов_по_ВЭС.pptx',
  ) {
    return Utils.downloadFile(`api/FERDashboardexport/${pathUrl}`, fileName, request, true);
  },
};
